import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { PropertyCarousel } from '../../../app-kit/components/PropertyCarousel/PropertyCarousel';
import type { FunctionComponent } from 'react';
import { mapBadgeVariant } from '../../../app-kit/helpers/mapBadgeVariant';
import { StyledProptrackLogoBrickSource } from '../../../components/ProptrackLogoBrickSource/ProptrackLogoBrickSource';

export const NeighbouringPropertiesWithData: FunctionComponent = () => {
  const data = usePropertyPageQuery()?.data.propertyPageBySlugV3;
  if (!data?.neighbouringPropertiesV2) return null;

  const { title, subtitle, properties, tracking } = data.neighbouringPropertiesV2;

  return (
    <ContentBrick title={title} subtitle={subtitle}>
      <PropertyCarousel
        key={properties.map((p) => p.pathV2).join('')}
        properties={properties.map(
          ({
            pathV2,
            clickThroughTracking,
            priceV2,
            address,
            imageV2,
            imageV3,
            badgeV2,
            features,
          }) => ({
            path: pathV2,
            clickThroughSource: clickThroughTracking,
            title: priceV2,
            titleExtra: null,
            subtitle: address,
            image: imageV3 ?? imageV2,
            badge: {
              ...badgeV2,
              variant: mapBadgeVariant(badgeV2.variant),
            },
            features: features?.map((feature) => ({ ...feature, iconName: feature.iconNameV2 })),
          }),
        )}
        tracking={tracking?.showMoreProperties}
      />
      <StyledProptrackLogoBrickSource />
    </ContentBrick>
  );
};
